/*
  SkillDetailModal
*/

import React, { Component } from 'react';
import autoBind from 'react-autobind';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import moment from 'moment';

import routeTemplates from 'ui/common/routes/templates';
import * as messages from './messages';
import * as actionTypes from 'store/graphql/SkillDetailModal/action-types';
import { isSkillValidatable, isAIPEnabled, isChatbotEnabled } from 'resources/validations';
import SkillLevelIncrementDecrement from 'ui/users/skills/level-increment-and-decrement';
import LoadingSpinner from 'ui/common/rebranding/components/LoadingSpinner';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'ui/common/dropdown';
import { push } from 'react-router-redux';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import SkillDetailModalReducer from 'store/graphql/SkillDetailModal/reducer';

import {
  selectError,
  selectFetching,
  selectSkillId,
  selectName,
  selectBestValidatedLevel,
  selectCurrentLevel,
  selectCategory,
  selectClaimLevel,
  selectChatbotLevel,
  selectClaimStatus,
  selectChatbotStatus,
  selectLatestClaimTimestamp,
  // selectLatestChatbotTimestamp,
  selectIsHighlighted,
  selectValidations,
  selectBeginnerCount,
  selectIntermediateCount,
  selectExpertCount,
} from 'store/graphql/SkillDetailModal/selectors';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/common/modal';

import UserUpdateSkillButton from 'ui/graphql/UserUpdateSkillButton';
import UserDeleteSkillButton from 'ui/graphql/UserDeleteSkillButton';
import Table, {
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from 'ui/common/rebranding/components/Table';
import Icon from 'ui/common/icon';
import styles from './index.module.scss';
import { skillCategories } from 'resources/skills/categories';
import { skillLevels } from 'resources/skills/levels';
import SkillValidationButton from 'ui/badges/skill-validation-button/loadable';
import Chatbot from 'ui/badges/chatbot';
import FetchAIPSkillsReducer from 'store/graphql/FetchAipSkills/reducer';
import { selectAIPSkills } from 'store/graphql/FetchAipSkills/selectors';

export const MODAL_NAME = id => `skill-user-detail-random-${id}`;
export const FORM_NAME = id => `skill-user-detail-${id}`;

class SkillDetailModal extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      claimDropdown: false,
      chatbotDropdown: false,
    };
  }

  onSubmit(values) {
    return true;
  }

  toggleDropdown(key) {
    this.setState({
      [key]: !this.state[key],
    });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && prevProps.isOpen !== this.props.isOpen) {
      this.graphqlGetSkillDetail();
    }
  }

  updateSkillLevel(entry) {
    const { updateModalSkillLevel } = this.props;
    const { currentLevel } = entry;

    if (currentLevel) {
      updateModalSkillLevel({ currentLevel });
    }
  }

  async graphqlGetSkillDetail() {
    const {
      client,
      getSkillDetailStart,
      getSkillDetailSuccess,
      getSkillDetailError,
      name,
    } = this.props;
    getSkillDetailStart();

    const graphqlResult = await client.query({
      query: gql`
        query getSkill($name: String!) {
          getSkill(name: $name) {
            skill {
              level
              isHighlighted
              _id
              validations {
                validated
                level
                type
              }
              skill {
                category
                name
              }
              # latestChatbotTimestamp
              latestClaimTimestamp
            }
          }
        }
      `,
      variables: {
        name,
      },
    });

    if (graphqlResult.errors) {
      const { message } = graphqlResult.errors[0];
      getSkillDetailError({
        error: message,
      });
    } else {
      const { skill } = graphqlResult.data.getSkill;
      getSkillDetailSuccess({ skill });
    }
  }

  render() {
    const { intl: { formatMessage } } = this.props;
    const {
      skillId,
      name,
      category,
      currentLevel,
      bestValidatedLevel,
      isHighlighted,
      claimLevel,
      chatbotLevel,
      claimStatus,
      chatbotStatus,
      validations,
      beginnerCount,
      intermediateCount,
      expertCount,
      fetching,
      isOpen,
      closeFn,
      latestClaimTimestamp,
      // latestChatbotTimestamp,
      push,
      aipSkills,
    } = this.props;

    // TO ensure skillCategories helper does not break
    if (!category.length || !currentLevel.length) return null;

    const entryForUpUpDownDown = {
      level: {
        name: name,
        power: skillLevels[currentLevel].power,
      },
      validations: validations.asMutable(),
      skill: {
        category: {
          id: category,
          name: category,
          className: skillCategories[category].className,
        },
        name,
      },
      validationCountsBySkillLevelIds: {
        beginner: beginnerCount,
        intermediate: intermediateCount,
        expert: expertCount,
      },
      isValidatedAtCurrentLevel:
        currentLevel === bestValidatedLevel && (claimStatus || chatbotStatus),
    };

    return (
      <Modal isOpen={isOpen}>
        <ModalHeader toggle={closeFn} />
        <ModalBody>
          {!fetching ? (
            <div>
              <div className="container">
                <div className="row justify-content-center">
                  <SkillLevelIncrementDecrement
                    entry={entryForUpUpDownDown}
                    updateSkillLevel={this.updateSkillLevel}
                  />
                </div>
                <div className="row">
                  <div className="col-12">
                    <center>
                      <div>
                        <p className="gray d-inline pr-1 text-small">
                          {formatMessage(messages.status.title)}
                        </p>
                        <div className="d-inline text-small">
                          {currentLevel === bestValidatedLevel ? (
                            <strong>{formatMessage(messages.status.validated)}</strong>
                          ) : (
                            <strong>{formatMessage(messages.status.unvalidated)}</strong>
                          )}
                        </div>
                      </div>
                    </center>
                  </div>
                </div>

                <div className="row">
                  {isSkillValidatable(name, aipSkills) && (
                    <div className="col-12 text-center my-3">
                      <SkillValidationButton skillName={name}>
                        {formatMessage(messages.buttons.submitValidation, {
                          level: currentLevel,
                        })}
                      </SkillValidationButton>
                    </div>
                  )}

                  <div className="col-12 my-3">
                    <Table>
                      <TableHead>
                        <TableRow className={classnames(styles.borderBottomGray)}>
                          <TableCell width="40%">
                            <p className="gray">{formatMessage(messages.tableHeaders.skills)}</p>
                          </TableCell>
                          <TableCell width="30%">
                            <p className="gray">{formatMessage(messages.tableHeaders.category)}</p>
                          </TableCell>
                          <TableCell width="30%">
                            <p className="gray">{formatMessage(messages.tableHeaders.level)}</p>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow className={classnames(styles.borderBottomGray)}>
                          <TableCell>{name && name.toUpperCase()}</TableCell>
                          <TableCell>{category && category.toUpperCase()}</TableCell>
                          <TableCell>{currentLevel && currentLevel.toUpperCase()}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </div>
                  <div className="col-12 text-center my-3">
                    <UserUpdateSkillButton
                      skillName={name}
                      level={currentLevel}
                      isHighlighted={isHighlighted}
                      closeModalFn={closeFn}
                      isReady={false}
                    >
                      {isHighlighted
                        ? formatMessage(messages.buttons.removeHighlighted)
                        : formatMessage(messages.buttons.addHighlighted)}
                    </UserUpdateSkillButton>
                  </div>
                  {isSkillValidatable(name, aipSkills) && (
                    <div className="col-12 my-3">
                      <Table>
                        <TableHead>
                          <TableRow className={classnames(styles.borderBottomGray)}>
                            <TableCell isFaded>
                              <p className="gray">
                                {formatMessage(messages.tableHeaders.validationType)}
                              </p>
                            </TableCell>
                            <TableCell isFaded>
                              <p className="gray">{formatMessage(messages.tableHeaders.level)}</p>
                            </TableCell>
                            <TableCell isFaded>
                              <p className="gray">{formatMessage(messages.tableHeaders.status)}</p>
                            </TableCell>
                            <TableCell />
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {claimLevel &&
                            isAIPEnabled(name, aipSkills) && (
                              <TableRow className={classnames(styles.borderBottomGray)}>
                                <TableCell>
                                  {formatMessage(messages.validationTypes.claim)}
                                </TableCell>
                                <TableCell>
                                  {formatMessage(messages.levels[claimLevel.toLowerCase()])}
                                </TableCell>
                                <TableCell>{claimStatus ? 'Passed' : 'Not passed'}</TableCell>
                                <TableCell>
                                  <Dropdown
                                    isOpen={this.state.claimDropdown}
                                    toggle={() => this.toggleDropdown('claimDropdown')}
                                    direction="left"
                                  >
                                    <DropdownToggle caret>
                                      <Icon name="icon--more" background size={15} />
                                    </DropdownToggle>
                                    <DropdownMenu>
                                      <DropdownItem
                                        className="cursor-pointer"
                                        onClick={() => {
                                          window.scrollTo(0, 0);
                                          push(routeTemplates.claims.new);
                                        }}
                                      >
                                        {formatMessage(messages.buttons.submitClaim)}
                                      </DropdownItem>
                                      {latestClaimTimestamp && (
                                        <DropdownItem legend>
                                          {formatMessage(messages.lastValidation.claim, {
                                            timestamp: moment(latestClaimTimestamp).format(
                                              'MMMM Do YYYY'
                                            ),
                                          })}
                                        </DropdownItem>
                                      )}
                                    </DropdownMenu>
                                  </Dropdown>
                                </TableCell>
                              </TableRow>
                            )}

                          {isChatbotEnabled(name, aipSkills) &&
                            chatbotLevel && (
                              <TableRow className={classnames(styles.borderBottomGray)}>
                                <TableCell>
                                  {formatMessage(messages.validationTypes.chatbot)}
                                </TableCell>
                                <TableCell>
                                  {formatMessage(messages.levels[chatbotLevel.toLowerCase()])}
                                </TableCell>
                                <TableCell>{chatbotStatus ? 'Passed' : 'Not passed'}</TableCell>
                                <TableCell>
                                  {!(chatbotLevel.toLowerCase() === 'expert' && chatbotStatus) && (
                                    <Dropdown
                                      isOpen={this.state.chatbotDropdown}
                                      toggle={() => this.toggleDropdown('chatbotDropdown')}
                                      direction="right"
                                    >
                                      <DropdownToggle caret>
                                        <Icon name="icon--more" background size={15} />
                                      </DropdownToggle>
                                      <DropdownMenu>
                                        <DropdownItem
                                          className="cursor-pointer"
                                          onClick={() => closeFn()}
                                        >
                                          <Chatbot isLink skillName={name} className="mx-1 mb-1">
                                            {formatMessage(messages.buttons.takeChatbot)}
                                          </Chatbot>
                                        </DropdownItem>
                                        {/* {latestChatbotTimestamp && (
                                          <DropdownItem legend>
                                            {formatMessage(messages.lastValidation.chatbot, {
                                              timestamp: moment(latestChatbotTimestamp).format(
                                                'MMMM Do YYYY'
                                              ),
                                            })}
                                          </DropdownItem>
                                        )} */}
                                      </DropdownMenu>
                                    </Dropdown>
                                  )}
                                </TableCell>
                              </TableRow>
                            )}
                        </TableBody>
                      </Table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <center>
              <LoadingSpinner />
            </center>
          )}
        </ModalBody>
        <ModalFooter className="mx-5">
          <UserDeleteSkillButton
            color="secondary"
            skillName={name}
            skillId={skillId}
            closeModalFn={closeFn}
          >
            {formatMessage(messages.buttons.delete)}
          </UserDeleteSkillButton>

          <UserUpdateSkillButton
            skillName={name}
            level={currentLevel}
            isHighlighted={isHighlighted}
            closeModalFn={closeFn}
            size="md"
            save
          >
            {formatMessage(messages.buttons.submit)}
          </UserUpdateSkillButton>
        </ModalFooter>
      </Modal>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    errorMessage: selectError(state),
    skillId: selectSkillId(state),
    name: selectName(state),
    bestValidatedLevel: selectBestValidatedLevel(state),
    currentLevel: selectCurrentLevel(state),
    category: selectCategory(state),
    claimLevel: selectClaimLevel(state),
    chatbotLevel: selectChatbotLevel(state),
    claimStatus: selectClaimStatus(state),
    chatbotStatus: selectChatbotStatus(state),
    latestClaimTimestamp: selectLatestClaimTimestamp(state),
    // latestChatbotTimestamp: selectLatestChatbotTimestamp(state),
    isHighlighted: selectIsHighlighted(state),
    validations: selectValidations(state),
    beginnerCount: selectBeginnerCount(state),
    intermediateCount: selectIntermediateCount(state),
    expertCount: selectExpertCount(state),
    fetching: selectFetching(state),
    aipSkills: selectAIPSkills(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSkillDetailStart: () => dispatch({ type: actionTypes.GET_SKILL_DETAIL.START }),
    getSkillDetailSuccess: ({ skill }) =>
      dispatch({ type: actionTypes.GET_SKILL_DETAIL.SUCCESS, payload: { skill } }),
    getSkillDetailError: error =>
      dispatch({ type: actionTypes.GET_SKILL_DETAIL.FAILURE, payload: { error } }),
    push: (routeName, locationState) => dispatch(push(routeName, locationState)),
    updateModalSkillLevel: ({ currentLevel }) =>
      dispatch({ type: actionTypes.UPDATE_SKILL_POWER, payload: { currentLevel } }),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({
  key: 'SkillDetailModal',
  reducer: SkillDetailModalReducer,
});

const withFetchAIPSkillsReducer = injectReducer({
  key: 'FetchAIPSkills',
  reducer: FetchAIPSkillsReducer,
});

export default compose(withReducer, withFetchAIPSkillsReducer, withConnect)(
  injectIntl(withApollo(SkillDetailModal))
);
